import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DemurrageService {
private readonly baseUrl = environment.apiBaseDemUrl;
  constructor(private http: HttpClient) { }


generateDemurragePdf(payload: any) {
  const url = `${this.baseUrl}/demurrage`;

  return this.http.post(url, payload, {
    responseType: 'blob' 
  }).pipe(
    catchError((error) => this.errorHandler(error))
  );
}
getDemurrageList() {
  const url = `${this.baseUrl}/demurrage/list?page=1&page_size=1000`;

  return this.http.get<any>(url).pipe(
    catchError((error) => this.errorHandler(error))
  );
}
getPdfBlob(url: string) {
  return this.http.get(url, {
    responseType: 'blob'
  });
}
getDemurrageById(id: number) {
  return this.http.get<any>(`${this.baseUrl}/demurrage/${id}`).pipe(
    catchError((error) => this.errorHandler(error))
  );
}

deleteDemurrage(id: number) {
  return this.http.delete<any>(`${this.baseUrl}/demurrage/${id}`).pipe(
    catchError((error) => this.errorHandler(error))
  );
}
updatePaymentStatus(id: number, payload: { payment_status: string; payment_status_date: string }): Observable<any> {
    const url = `${this.baseUrl}/demurrage/${id}/payment-status`;
    return this.http.patch<any>(url, payload).pipe(
      catchError((error) => this.errorHandler(error))
    );
  }
    errorHandler(error: HttpErrorResponse) {
      return throwError(() => error || 'Server Error');
    }
}
